/** Shared approval-engine copy (steps, refusals, decisions) used by stok and back office. */
export const enApprovals = {
  'approvals.status.pending': 'Waiting',
  'approvals.status.approved': 'Approved',
  'approvals.status.rejected': 'Rejected',
  'approvals.status.cancelled': 'Cancelled',
  'approvals.step.waiting': 'Not yet',
  'approvals.step.pending': 'Waiting for decision',
  'approvals.step.approved': 'Approved',
  'approvals.step.rejected': 'Rejected',
  'approvals.step.cancelled': 'Cancelled',
  'approvals.steps.title': 'Approval steps',
  'approvals.steps.desc':
    'Policy {policy} (version {version}), frozen when the request was submitted.',
  'approvals.steps.stepNo': 'Step {n}',
  'approvals.steps.needs': 'Needs {permission}',
  'approvals.steps.needsRole': 'Needs {permission} · role {role}',
  'approvals.steps.anyRole': 'any role',
  'approvals.steps.assigned': 'Escalated to {name}',
  'approvals.steps.escalationReason': 'Escalation: {reason}',
  'approvals.steps.decidedBy': '{name} · {time}',
  'approvals.steps.onBehalfOf': 'on behalf of {name}',
  'approvals.steps.note': 'Note: {note}',
  'approvals.steps.initiator': 'Submitted by {name} · {time}',
  'approvals.steps.none': 'No approval steps recorded for this request.',
  'approvals.perm.procurement.approve': 'Purchase approval',
  'approvals.perm.budget.approve': 'Budget approval',
  'approvals.perm.ap.approve': 'Payables approval',
  'approvals.perm.ap.verify': 'Payables verification',
  'approvals.perm.inventory.approve': 'Inventory approval',
  'approvals.refusal.initiator': 'You submitted this request; another person must decide.',
  'approvals.refusal.already_approved':
    'You already approved an earlier step; another person must decide this one.',
  'approvals.refusal.missing_permission': 'Your role does not have the permission this step needs.',
  'approvals.refusal.missing_role': 'This step needs a specific role that you do not hold.',
  'approvals.refusal.not_assigned': 'This step was escalated to someone else.',
  'approvals.refusal.not_pending': 'This request is no longer waiting for a decision.',
  'approvals.refusal.generic': 'You cannot decide this step.',
  'approvals.approve': 'Approve',
  'approvals.approving': 'Approving…',
  'approvals.reject': 'Reject',
  'approvals.rejecting': 'Rejecting…',
  'approvals.approveTitle': 'Approve {label}?',
  'approvals.approveBody': 'This decides step {n}: {step}.',
  'approvals.approveNote': 'Note',
  'approvals.rejectTitle': 'Reject {label}?',
  'approvals.rejectBody': 'The requester sees your reason and can change and resubmit.',
  'approvals.rejectReason': 'Reason',
  'approvals.approved': 'Approved.',
  'approvals.rejected': 'Rejected.',
  'approvals.budgetExceeded': 'Over budget: {available} available, {requested} requested.',
  'approvals.amount': 'Amount',
  'approvals.domain.purchase_request': 'Purchase request',
  'approvals.domain.purchase_order': 'Purchase order',
  'approvals.domain.supplier_invoice': 'Supplier invoice',
  'approvals.domain.ap_payment': 'Supplier payment',
  'approvals.domain.waste': 'Waste',
  'approvals.domain.stock_count': 'Stock count',
} as const;
